// import React from 'react';
// import QRCode from 'react-qr-code';
// import logoSrc from "../assets/images/k-logo-b.png";
// // import {QRCodeCanvas} from "qrcode.react";
// const QRCodeLogo = ({ value, flag }) => {
  
//   return (
//     <div id='canvas' className='d-flex flex-column align-items-center' style={{ position: 'relative' }}>
//       {/* Generate the QR code */}
//       <QRCode size={flag === 'G' ? 80 : 60} value={value} />
//       {/* <QRCodeCanvas
//         value={value}
//         size={flag === 'G' ? 80 : 60}
//         includeMargin={false}
//         imageSettings={{
//           src: logoSrc,
//           width: `${flag === 'G' ? 24 : 15}`,
//           height: `${flag === 'G' ? 24 : 15}`,
//           excavate: true,
//         }}
//       /> */}
//       <p style={{ fontSize: '0.1rem', margin: '0', position: 'absolute', bottom: '-13px', lineHeight: '0.4rem', fontWeight: '700', color: '#000', textAlign: 'center' }}>Activation Code</p>
//       {/* <p style={{ fontSize: '0.01rem', margin: '0', position: 'absolute', bottom: '-11px', lineHeight: '0.4rem', fontWeight: '700', color: '#000', textAlign: 'center' }}>{value.split('-')[1]}</p> */}
//       <small style={{ fontSize: '0.4rem', margin: '0', position: 'absolute', bottom: '-11px', fontWeight: '700', color: '#000', textAlign: 'center' }}>{value.split('-')[1]}</small>

//       {/* Overlay the logo in the center */}
//       <div
//         style={{
//           width: `${flag === 'G' ? '12%' : '12%'}`,
//           display: 'none',
//           position: 'absolute',
//           overflow: 'hidden',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           zIndex: 9999,
//           backgroundColor: '#fff',
//           borderRadius: '50%',
//         }}
//       >
//         <img src={logoSrc} alt='Logo' width={100} height={100} />
//       </div>
//     </div>
//   );
// };

// export default QRCodeLogo;

import React from 'react';
import QRCode from 'react-qr-code';

const QRCodeLogo = ({ value, flag }) => {
  const codeText = value.split('-')[1];

  return (
    <div
      id='canvas'
      style={{
        width: '1in',
        height: '1in',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingTop: '3px',
        paddingLeft: '1px',
        paddingBottom: '2px',
        boxSizing: 'border-box',
      }}
    >
      {/* Increase QR code size to 68px */}
      <QRCode value={value} size={80} />
      <small
        style={{
          fontSize: '10px',
          margin: '0',
          fontWeight: 700,
          color: '#000',
          textAlign: 'center',
          lineHeight: '1',
        }}
      >
        {codeText}
      </small>
      <p
        style={{
          fontSize: '10px',
          margin: '1px 0 0 0',
          fontWeight: 700,
          color: '#000',
          textAlign: 'center',
          lineHeight: '1.1',
        }}
      >
        Activation Code
      </p>
    </div>
  );
};

export default QRCodeLogo;
